import { render, staticRenderFns } from "./Company_pro_hazards.vue?vue&type=template&id=a3e65bd2&scoped=true&lang=pug&"
import script from "./Company_pro_hazards.vue?vue&type=script&lang=coffee&"
export * from "./Company_pro_hazards.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e65bd2",
  null
  
)

export default component.exports